import React from 'react';
import { Link } from 'react-router-dom';
import Table from 'antd/lib/table';
import 'antd/lib/table/style/index.css';
import 'antd/lib/pagination/style/index.css';
var tableStyles = require('src/imports/styles/extend.table.scss');
var ListCategoryRounds = function (props) {
    var rounds = props.rounds
        .filter(function (r) { return r.categoryId === props.category.id; })
        .sort(function (a, b) { return a.index - b.index; });
    var columns = [{
            title: 'Rounds',
            dataIndex: 'name',
            key: 'name',
            render: function (name, round) { return (React.createElement(Link, { to: "rounds/" + round.id }, name)); },
        }, {
            title: 'Routes',
            dataIndex: 'routeCount',
            key: 'routeCount',
            sorter: function (a, b) { return a.routeCount - b.routeCount; },
            className: tableStyles.colCenter,
        },
    ];
    return (React.createElement(Table, { size: 'small', rowKey: 'id', columns: columns, dataSource: rounds, locale: {
            emptyText: React.createElement("span", null,
                "No rounds in ",
                props.category.name),
        }, pagination: false, bordered: false, style: { background: '#FFF' } }));
};
export default ListCategoryRounds;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListCategoryPage/ListCategoryRounds.tsx
// module id = 1086
// module chunks = 0